import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, Output, EventEmitter, } from "@angular/core";
import { MatSlideToggleChange, MatSlideToggleModule } from "@angular/material/slide-toggle";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MatSlideToggleModule],
  selector: "mapfre-slide-toggle",
  templateUrl: "./mapfre-slide-toggle.component.html"
})
export class MapfreSlideToggleComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() isAcmic: boolean;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() label = '';
  @Output() toggleChange = new EventEmitter<boolean>();

  onToggleChange(event: MatSlideToggleChange): void {
    this.toggleChange.emit(event.checked);
  }
}
